import { useContext } from 'react';
import warning from 'warning';
import { defaults } from '@immediate_media/design-tokens';
import ThemeContext from '../../context/ThemeContext.js';
const useDesignTokens = () => {
  const {
    tokens = defaults
  } = useContext(ThemeContext);
  process.env.NODE_ENV !== "production" ? warning(tokens, 'Theme-specific design tokens cannot be loaded as no theme has been set via the ThemeProvider.') : void 0;
  return tokens || defaults;
};
export default useDesignTokens;